<template>
  <div>
    <el-row
      v-for="(item, index) in inputItems"
      type="flex"
      :key="index + ''"
      justify="space-between"
      style="font-size: 35px; margin-top: 10px; width: 820px"
    >
      <el-col style="text-align: left; line-height: 50px" :span="12">
        <span>{{ inputItems[index]["title"] }}:</span>
      </el-col>
      <el-col :span="12">
        <el-input
          v-if="inputItems[index]['type'] === 'input'"
          @mousedown="$event.preventDefault()"
          @focus="handleClick(index)"
          v-model="inputItems[index]['val']"
          :placeholder="inputItems[index]['placeholder']"
          :disabled="initInputDisabled"
        ></el-input>
      </el-col>
    </el-row>
    <div style="margin-top: 10px; display: flex; justify-content: space-between">
      <el-select v-model="dhcp" style="width: 300px">
        <el-option :value="dhcpItem.items[0].value" :label="dhcpItem.items[0].option"></el-option>
        <el-option :value="dhcpItem.items[1].value" :label="dhcpItem.items[1].option"></el-option>
      </el-select>
      <el-button @click="disconnect" v-if="isWifi">{{ $t("langcfg.txtDisconnect") }}</el-button>
      <el-button @click="reconnect">{{ $t("langcfg.txtReconnect") }}</el-button>
      <el-button @click="cancel" v-if="showCancelBtn || isWifi">{{
        $t("langcfg.txtCancel")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import EVENTS from "../../../bus";
export default {
  data() {
    return {
      autoUpload: false,
      inputDisabled: false,
      dhcp: "auto",
      dhcpItem: {
        title: "DHCP",
        type: "select",
        field: "method",
        keybordType: "next",
        val: this.wifiCfg["method"] || "",
        items: [
          {
            option: this.$t("langcfg.txtDHCP"),
            value: "auto"
          },
          {
            option: this.$t("langcfg.txtStatic"),
            value: "manual"
          }
        ]
      },
      inputItems: [
        {
          title: "IP",
          field: "address",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["address"] || "",
          placeholder: ""
        },
        {
          title: this.$t("langcfg.txtGateWay"),
          field: "gateway",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["gateway"] || "",
          placeholder: ""
        },
        {
          title: this.$t("langcfg.txtMask"),
          field: "mask",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["mask"] || "",
          placeholder: ""
        },
        {
          title: "DNS",
          field: "dns",
          type: "input",
          class: "normal",
          keybordType: "num",
          val: this.wifiCfg["dns"] || "",
          placeholder: ""
        }
      ],
      currentLanguage: "",
      showCancelBtn: false
    };
  },
  props: {
    wifiItem: Object,
    wifiCfg: Object,
    show: Boolean,
    isWifi: {
      type: Boolean,
      default: true
    }
  },
  created: function () {
    this.currentLanguage = window.settings.language;
  },
  mounted: function () {
    this.dhcp =
      this.wifiCfg["method"] === "DHCP" || this.wifiCfg["method"] === "auto" ? "auto" : "manual";
  },
  methods: {
    handleClick: function (index) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.inputItems[index].val, (inputData) => {
        self.inputItems[index].val = inputData;
        this.showCancelBtn = true;
      });
    },
    checkIpv4Config: function (config) {
      let reg =
        /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      return reg.test(config);
    },
    disconnect: function () {
      this.$emit("disconnect", this.wifiCfg);
    },
    reconnect: function () {
      let err = false;
      for (let id in this.inputItems) {
        if (
          this.inputItems[id]["type"] !== "select" &&
          !this.checkIpv4Config(this.inputItems[id]["val"])
        ) {
          this.inputItems[id]["class"] = "red";
          err = true;
          break;
        }
      }
      if (err) {
        return;
      }
      let obj = JSON.parse(JSON.stringify(this.wifiCfg));
      for (let id in this.inputItems) {
        obj[this.inputItems[id].field] = this.inputItems[id].val;
      }
      obj.method = this.dhcp;

      this.$emit("reconnect", obj);
    },
    cancel: function () {
      for (let id in this.inputItems) {
        this.inputItems[id].val = this.wifiCfg[this.inputItems[id].field];
      }
      this.showCancelBtn = false;
      this.$emit("cancel");
    }
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    },
    initInputDisabled: function () {
      let disabled = this.dhcp === "auto";

      return disabled;
    }
  }
};
</script>
<style lang="less" scoped>
.normal {
  color: black;
  width: 100%;
  border: none;
}
.red {
  color: black;
  width: 100%;
  border: 2px red solid;
}
.loginSelect {
  color: black;
  font-size: 25px;
  float: left;
  color: black;
  width: 180px;
  height: 52px;
}
.cb_AutoUpload {
  width: 35px;
  height: 35px;
}
.btn-loginOK {
  width: 100px;
  height: 50px;
  font-size: 20px;
}
.btn-logincancel {
  width: 100px;
  height: 50px;
  margin-left: 150px;
  font-size: 20px;
}
.buttonArea {
  position: fixed;
  top: 380px;
  left: 10px;
  width: 800px;
  text-align: center;
}
input:disabled {
  color: gray;
  border-left: 1px solid gray;
}
.el-button {
  margin-left: 1%;
  font-size: @header-fs;
  padding: 12px 15px;
  border: 1px solid gray;
}
.el-button:hover {
  opacity: 0.7;
}
.dialog /deep/ .el-input__inner {
  background-color: #2d3039;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/NetworkInfo.vue